var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 21 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M3.31 2.69 2.25 1.627.127 3.75l1.059 1.06L8.376 12l-7.185 7.19-1.064 1.06 2.123 2.123 1.06-1.059 7.19-7.19 7.19 7.185 1.06 1.064 2.124-2.123-1.06-1.06-7.19-7.19 7.185-7.19 1.064-1.06-2.123-2.124-1.06 1.065-7.19 7.185z"
  })));
};
export default SvgClose;